module.exports = __webpack_public_path__ + "img/pic_160441.cafcf4ed.jpg";